
import { Vue, Component, Prop } from 'vue-property-decorator'
import setting from '@/settings'
import dayjs from 'dayjs'

@Component({
  name: 'detailview'
})

export default class DetailView extends Vue {
  private dayjs = dayjs

  get orderState () {
    return this.params.orderState === 3 ? 2 : this.params.orderState === 1 ? 1 : 3
  }

  @Prop({ type: Object })
  private params!: object|any

  get file1Src () {
    if (this.params.atts[0].path === 'lb') {
      return require('../../../../assets/statics/pics/defaultImage.png')
    }
    return setting.ossIp + '/' + this.params.atts[0].path
  }

  get file2Src () {
    if (this.params.atts[1].path === 'lb') {
      return require('../../../../assets/statics/pics/defaultImage.png')
    }
    return setting.ossIp + '/' + this.params.atts[1].path
  }
}
